import { render, staticRenderFns } from "./ScopedVendorCompItemForm.vue?vue&type=template&id=fd672e06"
import script from "./ScopedVendorCompItemForm.vue?vue&type=script&lang=js"
export * from "./ScopedVendorCompItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports